import { dynamic } from '#/utils/dynamic';

export const userDashboardModalComponentByType = {
  INFORMATION_REQUIRED: dynamic(
    () =>
      import('./InformationRequired/InformationRequiredModal').then(
        (module) => ({ default: module.InformationRequiredModal }),
      ),
    { strategy: 'always' },
  ),
  NOTIFICATION_PREFERENCES: dynamic(
    () =>
      import('./NotificationPreferences/NotificationPreferencesModal').then(
        (module) => ({ default: module.NotificationPreferencesModal }),
      ),
    { strategy: 'always' },
  ),
  DELETE_ACCOUNT: dynamic(
    () =>
      import('./DeleteAccount/DeleteAccountModal').then((module) => ({
        default: module.DeleteAccountModal,
      })),
    { strategy: 'always' },
  ),
  MAKE_PROFILE_PRIVATE: dynamic(
    () =>
      import('./MakeProfilePrivate/UserDashboardMakeProfilePrivateModal').then(
        (module) => ({ default: module.UserDashboardMakeProfilePrivateModal }),
      ),
    { strategy: 'always' },
  ),
  ADD_EDIT_WORK_HISTORY_JOB: dynamic(
    () =>
      import('./AddEditWorkHistoryJob/AddEditWorkHistoryJobModal').then(
        (module) => ({ default: module.AddEditWorkHistoryJobModal }),
      ),
    { strategy: 'always' },
  ),
  ADD_EDIT_EDUCATION_HISTORY: dynamic(
    () =>
      import('./AddEditEducationHistory/AddEditEducationHistoryModal').then(
        (module) => ({ default: module.AddEditEducationHistoryModal }),
      ),
    { strategy: 'always' },
  ),
  DELETE_WORK_HISTORY_JOB: dynamic(
    () =>
      import('./DeleteWorkHistoryJob/DeleteWorkHistoryJobModal').then(
        (module) => ({ default: module.DeleteWorkHistoryJobModal }),
      ),
    { strategy: 'always' },
  ),
  DELETE_EDUCATION_HISTORY: dynamic(
    () =>
      import('./DeleteEducationHistory/DeleteEducationHistoryModal').then(
        (module) => ({ default: module.DeleteEducationHistoryModal }),
      ),
    { strategy: 'always' },
  ),
  INTAKE_INTENTS: dynamic(
    () =>
      import('./IntakeIntents/UserDashboardIntakeIntentsModal').then(
        (module) => ({ default: module.UserDashboardIntakeIntentsModal }),
      ),
    { strategy: 'always' },
  ),
  CURATE_SEARCH: dynamic(
    () =>
      import('#/modules/userDashboard/curateSearch/modal/UserDashboardCurateSearchModal').then(
        (module) => ({
          default: module.UserDashboardCurateSearchModal,
        }),
      ),
    { strategy: 'always' },
  ),
  RESUME_RECOMMENDER_ONBOARDING: dynamic(
    () =>
      import('#/modules/userDashboard/resumeRecommender/ResumeRecommenderModal').then(
        (module) => ({ default: module.ResumeRecommenderModal }),
      ),
    { strategy: 'always' },
  ),
  PROFILE_WIZARD: dynamic(
    () =>
      import('#/modules/userDashboard/profile/modals/Wizard/UserDashboardProfileWizardModal').then(
        (module) => ({
          default: module.UserDashboardProfileWizardModal,
        }),
      ),
    { strategy: 'always' },
  ),
  EDIT_SAVED_SEARCH: dynamic(
    () =>
      import('./EditSavedSearch/EditSavedSearchModal').then((module) => ({
        default: module.EditSavedSearchModal,
      })),
    { strategy: 'always' },
  ),
  FIND_ORG: dynamic(
    () =>
      import('./FindOrganization/FindOrganizationModal').then((module) => ({
        default: module.FindOrganizationModal,
      })),
    { strategy: 'always' },
  ),
} as const satisfies Record<string, unknown>;
